import React from 'react';
import { Button } from 'react-bootstrap';
import { SendDocumentButtonMessage } from '../../../../../document-table/DocumentTableConstants';
import { TitleFormattedMessage } from '../../../../../titleFormattedMessage';
import styles from './styles.module.scss';

interface SendProps {
  disabled: boolean;
  onClick: () => void;
}

const Send = ({ disabled, onClick }: SendProps) => {
  return (
    <Button className={styles['send-button']} disabled={disabled} onClick={onClick} variant={'primary'}>
      <TitleFormattedMessage
        id="document-wizard-header.action.share-draft"
        defaultMessage={SendDocumentButtonMessage.SEND_FOR_REVIEW}
        data-testid="document-wizard-header-share-draft-action"
      />
    </Button>
  );
};

export default Send;
